<template>
  <div
    class="filter-item-string d-flex flex-wrap align-items-center gap-2"
    style="position: relative"
  >
    <div class="d-flex align-items-center">
      <b-form-select
        class="flex-1"
        :modelValue="filterItemService?.value?.operator || 'contains'"
        @update:modelValue="updateOperator"
        :options="options"
        size="sm"
      ></b-form-select>
    </div>
    <div v-if="operator === 'in'">
      <div v-if="!selectionHasLoaded">
        <Loading />
      </div>
      <div
        v-if="selectionHasLoaded && selections.length > 0"
        class="small"
      >
        <multiselect
          v-if="selections.length > 20"
          :allow-empty="true"
          :show-labels="true"
          select-label="選択"
          placeholder="選択"
          :model-value="modelValue"
          :internal-search="false"
          :options="selections"
          :multiple="true"
          @update:modelValue="change"
        >
          <template #noOptions> --- </template>
          <template #noResult> --- </template>
        </multiselect>
        <b-form-checkbox-group
          v-else
          :model-value="modelValue || []"
          @update:modelValue="change"
        >
          <b-form-checkbox
            v-for="option in selections"
            :key="option"
            :value="option"
            v-show="option !== null && option !== ''"
            class="d-flex align-items-center"
          >
            {{ option }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </div>
    </div>
    <div v-if="operator !== 'isnull' && operator !== 'isnotnull' && operator !== 'in'">
      <b-form-input
        ref="filterItemFormInput"
        size="sm"
        :modelValue="modelValue"
        @update:modelValue="change"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { inject, PropType } from 'vue'
import { FilterItemService } from '../../../FilterItemService'
import {
  FILTER_OPERATOR_FOR_STRING,
  FILTER_OPERATOR_FOR_UUID,
} from '../../../FilterRuleService'

export default {
  props: {
    modelValue: {
      type: [String, Array] as PropType<string | string[]>,
      required: true,
    },
  },
  data() {
    return {
      operator: null,
      isVisibleSetting: false,
      selectionHasLoaded: false,
      selections: [] as string[],
    }
  },
  computed: {
    filterItemService(): FilterItemService<any> {
      // @ts-ignore
      return (
        this.$provides?.filterItemService?.value || this.$provides?.filterObject?.value
      )
    },
    label() {
      return this.filterItemService.colDef.label || this.filterItemService.colDef.name
    },
    options() {
      // { value: xxxx'', text: 'xxxxx' }のような形で返す
      const op =
        this.filterItemService.colDef.type === 'UUID'
          ? FILTER_OPERATOR_FOR_UUID
          : FILTER_OPERATOR_FOR_STRING
      return Object.keys(op).map((operator) => {
        return {
          value: operator,
          text: op[operator],
        }
      })
    },
  },
  watch: {
    'filterItemService.isFocus'(val) {
      if (val && this.$refs.filterItemFormInput) {
        this.$refs.filterItemFormInput.focus()
      }
    },
    'filterItemService.colDef.name'(newVal, oldVal) {
      if (newVal !== oldVal && this.operator === 'in') {
        this.loadSelections()
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.operator = this.filterItemService?.value?.operator
      if (!this.operator) {
        this.operator = this.options.length > 0 ? this.options[0].value : null
      }
      if (this.operator === 'in') {
        this.loadSelections()
      }
      setTimeout(() => {
        this.$refs?.filterItemFormInput?.focus?.()
      }, 100)
    })
  },
  methods: {
    toggleSetting() {
      this.isVisibleSetting = !this.isVisibleSetting
    },
    change(value) {
      this.$emit('update:modelValue', {
        value,
        operator: this.operator,
      })
    },
    updateOperator(value) {
      this.operator = value
      if (this.operator === 'in') {
        this.change(null)
        this.loadSelections()
      }
      if (this.operator !== 'in' && typeof this.modelValue !== 'string') {
        this.change('') // 文字列でない場合は空文字列にする
      } else if (this.operator === 'isnull' || this.operator === 'isnotnull') {
        this.change('')
      }
      this.$emit('update:operator', this.operator)
    },
    onDismissDropDown() {
      this.$emit('onDismissDropdown')
    },
    async loadSelections() {
      this.selectionHasLoaded = false
      // カラムのデータを facet で取得する
      const modelName = this.filterItemService?.modelName
      const colName = this.filterItemService?.colDef?.name
      if (!modelName || !colName) return
      this.selections =
        (await $core.$models[modelName]?.fetchFacetNamesByColName?.(colName)) || []
      this.$nextTick(() => {
        this.selectionHasLoaded = true
      })
    },
  },
}
</script>
